"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MtsStatus = exports.OddsChangeMode = exports.TicketStatus = exports.TicketType = void 0;
var TicketType;
(function (TicketType) {
    TicketType["Single"] = "Single";
    TicketType["Express"] = "Express";
    TicketType["System"] = "System";
})(TicketType || (exports.TicketType = TicketType = {}));
var TicketStatus;
(function (TicketStatus) {
    TicketStatus["Rejected"] = "Rejected";
    TicketStatus["Accepted"] = "Accepted";
    TicketStatus["Win"] = "Win";
    TicketStatus["Lose"] = "Lose";
    TicketStatus["WinVoid"] = "WinVoid";
    TicketStatus["LoseVoid"] = "LoseVoid";
    TicketStatus["Void"] = "Void";
    TicketStatus["Cancelled"] = "Cancelled";
    TicketStatus["DeadHeat"] = "DeadHeat";
})(TicketStatus || (exports.TicketStatus = TicketStatus = {}));
var OddsChangeMode;
(function (OddsChangeMode) {
    OddsChangeMode["Exact"] = "Exact";
    OddsChangeMode["Higher"] = "Higher";
    OddsChangeMode["Any"] = "Any";
})(OddsChangeMode || (exports.OddsChangeMode = OddsChangeMode = {}));
var MtsStatus;
(function (MtsStatus) {
    MtsStatus["Rejected"] = "Rejected";
    MtsStatus["Accepted"] = "Accepted";
    MtsStatus["Cancelled"] = "Cancelled";
    MtsStatus["NotCancelled"] = "NotCancelled";
})(MtsStatus || (exports.MtsStatus = MtsStatus = {}));
//# sourceMappingURL=betprocessor.js.map